// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-title-hM03fu{margin-bottom:8px;font-size:16px;font-weight:600}.info-subtitle-xJLDxa{margin-top:12px;margin-bottom:8px;font-size:14px;font-weight:500}.container-LF_kv1{width:100%;height:100%}.diff-table-tF4K3Z{margin-bottom:24px}.diff-table-tF4K3Z .semi-table-row-head{border-bottom:1px solid var(--semi-color-border);font-size:12px;background-color:rgba(46,46,56,.04)!important;padding:4px 8px!important}.diff-table-tF4K3Z .semi-table-row-cell{font-size:12px;padding:10px 8px!important}.cell-span-H_nQzL{word-break:break-word;font-weight:400;font-size:12px!important}.property-tooltip-ji9W4V{word-break:break-word}.empty-container-YLcORh{flex-direction:column;justify-content:center;align-items:center;height:100%;min-height:200px;display:flex}.empty-info-q193R7{margin-top:4px}.list-BE2Xcy{border-radius:8px;border:1px solid var(--Stroke-COZ-stroke-plus,rgba(6,7,9,.15))!important;background-color:#fff!important}.list-BE2Xcy .semi-list-item{border-bottom:1px solid var(--Stroke-COZ-stroke-plus,rgba(6,7,9,.15))!important}.list-BE2Xcy .semi-list-item:last-child{border-bottom:none!important}.list-item-vLj8Sw{grid-template-columns:280px 120px 1fr;align-items:center;display:grid}.tag-1-aqUUN6{color:#3ec254;background-color:#d2f3d5}.tag-2-CdvW0P,.tag-4-MC5w82{color:#ff441e;background-color:#ffe0d2}.tag-3-KTmcm_{color:#ff9600;background-color:#fff1cc}.property-title-Tuf6E1{color:var(--Fg-COZ-fg-primary,rgba(6,7,9,.8));font-size:12px;font-weight:500}.info-block-s33QB0:not(:first-child){margin-top:24px}.mask-U3tgbz{pointer-events:none;background:linear-gradient(to top,rgba(var(--coze-bg-2),1)0,rgba(var(--coze-bg-2),0)100%);width:100%;height:32px;position:absolute;bottom:80px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-title": `info-title-hM03fu`,
	"infoTitle": `info-title-hM03fu`,
	"info-subtitle": `info-subtitle-xJLDxa`,
	"infoSubtitle": `info-subtitle-xJLDxa`,
	"container": `container-LF_kv1`,
	"diff-table": `diff-table-tF4K3Z`,
	"diffTable": `diff-table-tF4K3Z`,
	"cell-span": `cell-span-H_nQzL`,
	"cellSpan": `cell-span-H_nQzL`,
	"property-tooltip": `property-tooltip-ji9W4V`,
	"propertyTooltip": `property-tooltip-ji9W4V`,
	"empty-container": `empty-container-YLcORh`,
	"emptyContainer": `empty-container-YLcORh`,
	"empty-info": `empty-info-q193R7`,
	"emptyInfo": `empty-info-q193R7`,
	"list": `list-BE2Xcy`,
	"list-item": `list-item-vLj8Sw`,
	"listItem": `list-item-vLj8Sw`,
	"tag-1": `tag-1-aqUUN6`,
	"tag1": `tag-1-aqUUN6`,
	"tag-2": `tag-2-CdvW0P`,
	"tag2": `tag-2-CdvW0P`,
	"tag-4": `tag-4-MC5w82`,
	"tag4": `tag-4-MC5w82`,
	"tag-3": `tag-3-KTmcm_`,
	"tag3": `tag-3-KTmcm_`,
	"property-title": `property-title-Tuf6E1`,
	"propertyTitle": `property-title-Tuf6E1`,
	"info-block": `info-block-s33QB0`,
	"infoBlock": `info-block-s33QB0`,
	"mask": `mask-U3tgbz`
};
export default ___CSS_LOADER_EXPORT___;
